import { useMemo } from 'react'

import { type SlackUser } from '@webapp/platform/integrations/entities/SlackUser/SlackUser'
import { useListSlackUsersModel } from '../../models/useListSlackUsersModel'

export const useListSlackUsersPresenter = (): {
  slackUserCache: Map<string, SlackUser>
  isLoading: boolean
} => {
  const { slackUsers, isLoading } = useListSlackUsersModel()

  const slackUserCache = useMemo(() => {
    const cache = new Map<string, SlackUser>()
    slackUsers.forEach((slackUser) => {
      cache.set(slackUser.id, slackUser)
    })
    return cache
  }, [slackUsers])

  return {
    slackUserCache,
    isLoading,
  }
}
